import {useQuery} from '@tanstack/react-query';
import {HousingLocation, QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

function useFetchHousingLocation({housingLocation}: {housingLocation?: string}) {
  return useQuery<HousingLocation, Error>({
    queryKey: [QUERY_CACHE_KEYS.housingLocation, housingLocation],
    queryFn: () => API.housing.getLocation({externalURL: housingLocation}),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(housingLocation),
  });
}

export {useFetchHousingLocation};
